<template>
  <div class="vue-towns-wrap">
    <div
    class="add-new-button-container"
    v-if="!createTownFormVisible && !selectedTown">
      <span
      class="add-new-button"
      @click="showCreateTownForm">+</span><span class="add-new-button-label">Add new town</span>
    </div>
    <b-spinner v-if="!towns || !towns.length" class="spinner"></b-spinner>
    <div v-if="towns && towns.length && !createTownFormVisible">
      <div class="header">Edit Town</div>
      <select-town-dropdown
      :towns="towns"
      :townSelected="onTownSelected"></select-town-dropdown>
    </div>
    <edit-town-form
    :counties="counties"
    v-if="selectedTown && !createTownFormVisible"
    :selectedTown="selectedTown"
    :destroySelectedTown="onDestroySelectedTown"
    :getAllTowns="onGetAllTownsRequested"></edit-town-form>
    <create-town-form
    :counties="counties"
    :hide="hideCreateTownForm"
    :createTownSuccess="onCreateTownSuccess"
    v-if="createTownFormVisible && !selectedTown"></create-town-form>
  </div>
</template>

<script>
import API from "@/services/api";
import EditTownForm from "./edit-town/EditTownForm";
import CreateTownForm from "./CreateTownForm";
import SelectTownDropdown from "./edit-town/SelectTownDropdown";

export default {
  name: 'AdminTown',
  components: {
    EditTownForm,
    CreateTownForm,
    SelectTownDropdown
  },
  props: {

  },
  data() {
    return {
      user: undefined,
      towns: [],
      counties: [],
      selectedTown: undefined,
      createTownFormVisible: undefined
    }
  },
  created() {
    this.getAllTowns();
    this.getAllCounties();
  },
  beforeCreate() {

  },
  methods: {
    async getAllTowns() {
      const towns = await API.GetTowns();

      if (towns && towns.length) {
        this.towns = towns;
      }
    },
    async getAllCounties() {
      const counties = await API.GetCounties();

      if (counties && counties.length) {
        this.counties = counties;
      }
    },
    onTownSelected(town) {
      if (!town){
        this.selectedTown = undefined;
        return;
      }

      this.selectedTown = JSON.parse(JSON.stringify(town));
      this.$forceUpdate();
    },
    onDestroySelectedTown() {
      this.selectedTown = undefined;
    },
    onGetAllTownsRequested() {
      this.getAllTowns();
    },
    showCreateTownForm() {
      setTimeout(() => this.createTownFormVisible = true, 50);
    },
    hideCreateTownForm() {
      this.createTownFormVisible = undefined;
    },
    onCreateTownSuccess() {
      this.hideCreateTownForm();
      this.getAllTowns();
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

.vue-towns-wrap{
  position: relative;

  .header{
    margin: 20px 0 20px 5px;
    font-weight: $bold;
    color: $black;
  }

  .create-town-button{
      position: absolute;
      top: 0;
      right: 0;
      background-color: #002D68;
      color: #fff;

      &:hover {
        background-color: #3d683c;
      }
  }
}
</style>
